'use strict';

angular.module('atex.art').factory('ArtLayoutService',
    ['$q', '$http', 'Application',

      function($q, $http, Application) {
        var locationStorageName;
        var sessionStorageName;

        var initialiseLocalStorage = function () {
          locationStorageName = 'copyfit.loc.' + Application.currentUser.principalId;
          sessionStorageName = 'copyfit.session.' + Application.currentUser.principalId;

          if (typeof localStorage[locationStorageName] === 'undefined') {
            localStorage[locationStorageName] = "";
          }

          if (typeof localStorage[sessionStorageName] === 'undefined') {
            localStorage[sessionStorageName] = "";
          }
        };

        var setAuthDetails = function (headers) {
          if ( headers ) {
            var authLocation = headers("X-Auth-Location");
            var authSession = headers("X-Auth-Session");

            if (authLocation !== null) {
              localStorage[locationStorageName] = authLocation;
            }

            if (authSession !== null) {
              localStorage[sessionStorageName] = authSession;
            }
          }
        };

        var getAuthDetails = function (headers) {
          initialiseLocalStorage();

          if (typeof localStorage[locationStorageName] === 'undefined') {
            localStorage[locationStorageName] = "";
          }

          if (typeof localStorage[sessionStorageName] === 'undefined') {
            localStorage[sessionStorageName] = "";
          }

          headers['X-Auth-Token'] = Application.currentUser.token;
          headers['X-Auth-Location'] = localStorage[locationStorageName];
          headers['X-Auth-Session'] = localStorage[sessionStorageName];
        };

        var content = function( options ) {
          if ( typeof options.contentId === 'undefined' ) {
            options.contentId = "";
          }
          if ( typeof options.headerFields === 'undefined' ) {
            options.headerFields = {};
          }
          if ( typeof options.layoutOptions === 'undefined' ) {
            options.layoutOptions = {};
          }
          if ( typeof options.subType === 'undefined' ) {
            options.subType = "print";
          }

          var hasData = (options.contentData !== undefined);

          var deferred = $q.defer();
          var strRequestContent = "/onecms/layout/handj/content/" + options.subType + "/" + options.contentId;
          var bFirst = 1;

           for ( var option in options.layoutOptions ) {
            if ( typeof options.layoutOptions[option] !== 'function' ) {
              if ( bFirst === 1 ) {
                strRequestContent = strRequestContent + "?";
              } else {
                strRequestContent = strRequestContent + "&";
              }

              bFirst = 0;
              strRequestContent = strRequestContent + option + "=" + options.layoutOptions[option];
            }
          }

          initialiseLocalStorage();

          var headers = {
            'Content-Type': 'application/json'
          };

          getAuthDetails( headers );

          for ( var name in options.headerFields ) {
            if ( typeof options.headerFields[name] !== 'function') {
              console.log("headerFields[name] = ", options.headerFields[name] );
              if ( options.headerFields[name] !== "" ) {
                headers[name] = options.headerFields[name];
              }
            }
          }

          var config = {
            method: ( hasData ? 'POST' : 'GET'),
            url: strRequestContent,
            headers: headers
          };

          if ( hasData ) {
            config.data = options.contentData;
          }

          $http( config ).
              then(function(response) {
                setAuthDetails(response.headers);
                deferred.resolve(response.data);

              }, function(response) {
                console.log( "content error status = ", response.status );
                console.log( "             content = ", response.data );

                setAuthDetails(response.headers);
                deferred.reject( response );
              });

          return deferred.promise;
        };

        return {
          getAuthDetails: getAuthDetails,
          setAuthDetails: setAuthDetails,
          content: content
        };
      }
    ]);
